import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import "antd/dist/antd.css";
import styles from "./Header.module.css";
import { Button, Col, Row, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { UserContext } from "../Reducers/UserContext";

const { Title } = Typography;

const SubscribeHead = (props) => {
  const { isLoggedIn, setLogger } = useContext(UserContext);
  const history = useHistory();

  return (
    <div className={styles.site_page_header_ghost_wrapper}>
      <div style={{ backgroundColor: "#555559", height: "60px" }}>
        <Row>
          {/* <Col span={1}></Col> */}
          <Col span={5}>
            <br />{" "}
            <Row>
              <div>
                <a onClick={() => history.push("/")}>
                  <img
                    src="/img/netskope-logo-white.svg"
                    alt=""
                    width="150px"
                    height="30px"
                  />
                </a>
              </div>
            </Row>
          </Col>
          <Col span={8}>{/* <TopMenus /> */}</Col>
        </Row>
      </div>
      <Row>
        <Button
          type="link"
          style={{
            // color: "#242424",
            paddingLeft: "40px",
            paddingTop: "12px",
            margin: "0px",
            paddingBottom: "2px",
            // fontFamily: "PingFangHK-Thin",
            // fontSize: "12px",
            // fontStyle: "normal",
            fontWeight: 300,
            // lineHeight: "40px",
          }}
          onClick={() => window.history.back()}
        >
          <ArrowLeftOutlined style={{ color: "black" }} /> Product Change
          Notification
        </Button>
      </Row>
      <Row>
        <Col span={15}>
          <Title
            level={2}
            style={{
              color: "#242424",
              paddingLeft: "40px",
              paddingTop: "2px",
              margin: "0px",
              paddingBottom: "2px",
              fontFamily: "PingFangHK-Thin",
              fontSize: "32px",
              fontStyle: "normal",
              fontWeight: 300,
              // lineHeight: "40px",
            }}
          >
            <>Your Subscriptions</>
          </Title>
        </Col>
      </Row>

      <Row>
        <Col span={15}>
          <span
            // level={2}
            style={{
              color: "#242424",
              paddingLeft: "40px",
              // paddingTop: "2px",
              margin: "0px",
              paddingBottom: "2px",
              fontFamily: "PingFangHK-Thin",
              fontSize: "14px",
              // fontStyle: "normal",
              fontWeight: 300,
              // lineHeight: "40px",
            }}
          >
            <>
              You will recieve emails whenever there is an update regarding the
              options you subscribe to.
            </>
          </span>
        </Col>
      </Row>
    </div>
  );
};

export default SubscribeHead;
